export interface ToolType {
    id?: number;
    category_id?: number;
    type_name?: string;
    path?: string | null;
    status?: 1 | 0;
}

// to single object maping
export const mapToolType = (data:any): ToolType => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: ToolType ={
        id: data.id,
        category_id: data.category_id,
        type_name: data.type_name,
        path: data.path,
        status: data.status,
    }
    return res;
}

// maping list objects
export const mapToolTypes = (data:any[]): ToolType[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapToolType);
}